export default __webpack_public_path__ + "static/media/Search.526f27c4.png";